import { Menu } from '@base-ui/react';
import cx from 'classnames';
import { useState } from 'react';

import styles from './NotificationCenter.scss';
import { Icon } from '@components/icon/Icon';
import typography from '@shared/styles/typography.scss';
import { Link } from 'react-router-dom';
import { useMessagingDrawer } from 'restaurantAdmin/messaging/hooks';
import { INBOX_PATH } from 'restaurantAdmin/paths';
import { useRestaurantMessagesQuery } from 'restaurantAdmin/messaging/hooks';
import { Notification } from 'restaurantAdmin/messaging/Notification';

export const NotificationCenter = () => {
  const [menuIsOpen, setMenuIsOpen] = useState(false);

  const { messagingDrawerSearchParams } = useMessagingDrawer();

  const { data: notifications = [] } = useRestaurantMessagesQuery();

  const hasUnreadMessages = notifications.some(
    (notification) => !notification.readAt,
  );

  return (
    <Menu.Root
      open={menuIsOpen}
      onOpenChange={(isOpen) => setMenuIsOpen(isOpen)}
    >
      <Menu.Trigger
        className={cx(styles.inboxButton, {
          [styles.unread]: hasUnreadMessages,
        })}
        aria-label="Open notification center"
      >
        <Icon name="inbox" />
      </Menu.Trigger>
      <Menu.Portal>
        <Menu.Positioner
          side="bottom"
          sideOffset={10}
          className={styles.positioner}
        >
          <Menu.Popup className={styles.popup}>
            <Menu.Arrow className={styles.arrow}>
              <Icon name="arrowPopover" />
            </Menu.Arrow>
            {hasUnreadMessages ? (
              <div>
                {notifications.map((notification) => (
                  <Menu.Item key={notification.id} className={styles.menuItem}>
                    <Link
                      to={
                        '?' +
                        messagingDrawerSearchParams([notification.user.id])
                      }
                      aria-label={`Open messaging drawer for ${notification.user.firstName} ${notification.user.lastName}`}
                      onClick={() => setMenuIsOpen(false)}
                    >
                      <Notification notification={notification} />
                    </Link>
                  </Menu.Item>
                ))}{' '}
              </div>
            ) : (
              <Menu.Item
                className={cx(styles.menuItem, styles.noUnreadMessages)}
              >
                <Icon name="inbox" />
                <p className={typography.h5}>No unread items</p>
              </Menu.Item>
            )}

            <div className={styles.inboxLinkContainer}>
              <Link
                to={INBOX_PATH}
                className={cx(typography.t1, styles.inboxLink)}
                onClick={() => setMenuIsOpen(false)}
              >
                <Icon name="inbox" className={styles.inboxIcon} />
                Go to Inbox
              </Link>
            </div>
          </Menu.Popup>
        </Menu.Positioner>
      </Menu.Portal>
    </Menu.Root>
  );
};
